import { CSSObject, Theme } from '@mui/material';
import {
  getDropdownSurfaceActiveBackground,
  getDropdownSurfaceBackground,
} from '@onevision-resources/design-theme';

/** Shared surface styling for MUI dropdown Paper (SelectMenu's Popover, AppMenu's Menu, …). */
export const getDropdownPaperSx = (theme: Theme): CSSObject => ({
  backgroundColor: getDropdownSurfaceBackground(theme),
  backgroundImage: 'none',
  border: '1px solid',
  borderColor: theme.palette.custom.OV.sys.outlineVariant,
  borderRadius: '0.75rem',
});

/** Shared surface + row styling for MUI `Menu` dropdowns (AppMenu and its submenus). */
export const getDropdownMenuPaperSx = (theme: Theme): CSSObject => {
  const activeBackground = getDropdownSurfaceActiveBackground(theme);
  return {
    ...getDropdownPaperSx(theme),
    padding: 0,
    '& .MuiList-root': { padding: '0.375rem' },
    '& .MuiMenuItem-root': {
      borderRadius: '0.5rem',
      marginBottom: '0.25rem',
      '&:hover': { backgroundColor: activeBackground },
      '&.Mui-selected': {
        backgroundColor: activeBackground,
        '&:hover': { backgroundColor: activeBackground },
      },
    },
  };
};
